import {
  ArrowDropDown,
  HelpCenter,
  Home,
  LocalShipping,
  MarkChatRead,
  Message,
  Person,
  Report,
  Settings,
  ShoppingBag,
  TrackChanges,
} from "@mui/icons-material";
import { React } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LoginModal = () => {
  const { currentUser, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Failed to logout:", error);
    }
  };

  return (
    <div className="relative group inline-block">
      Hello,{" "}
      {currentUser?.displayName || (
        <Link to="/login" className=" text-small ml-1 hover:text-cyan-400 ">
          Login
        </Link>
      )}
      <ArrowDropDown fontSize="small" />
      <div className="custom-modal">
        <div className="custom-arrow"></div>

        <div className=" mt-2 mb-4">
          {currentUser ? (
            <Link
              onClick={() => {
                handleLogout();
              }}
              className="mt-4 ml-2 text-small bg-coffee hover:bg-coffeeBrown text-white p-2 rounded hover:text-white"
            >
              Logout
            </Link>
          ) : (
            <div>
              <Link
                to="/login"
                className="mt-4 text-small bg-black text-white p-2 rounded hover:text-white"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="mt-4 ml-2 text-small bg-coffee hover:bg-coffeeBrown text-white p-2 rounded hover:text-white"
              >
                Register
              </Link>
            </div>
          )}
        </div>

        <Link
          to="/settings/profile"
          className=" p-2 text-small italic text-black"
        >
          {currentUser?.email}
        </Link>
        <div className=" border-b border border-coffee font-normal"></div>
        <div>
          <ul className=" text-gray-700 font-xs pt-2  ">
            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="/settings/profile"
              >
                <Person fontSize="small" className="mr-2" /> My Profile
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="/settings/orders"
              >
                <ShoppingBag fontSize="small" className="mr-2" /> My Orders
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="/settings/track"
              >
                <TrackChanges fontSize="small" className="mr-2" /> Tracking
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="/settings/shipped"
              >
                <LocalShipping fontSize="small" className="mr-2" /> Shipped
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="/settings/address_book"
              >
                <Home fontSize="small" className="mr-2" /> Address Book
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="settings/messages"
              >
                <Message fontSize="small" className="mr-2" /> My Messages
              </Link>
            </li>

            <li>
              <Link
                className=" flex p-1 text-small hover:text-white  hover:bg-coffee"
                to="settings/wishlist"
              >
                <MarkChatRead fontSize="small" className="mr-2" /> Wish List
              </Link>
            </li>
            <div className=" border-b border border-gray-400 my-1 font-normal"></div>

            <li>
              <Link
                className=" flex p-1 text-small text-gray-500 hover:text-white hover:bg-coffee"
                to="/settings/terms"
              >
                <Settings fontSize="small" className="mr-2" /> Settings
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small text-gray-500 hover:text-white hover:bg-coffee"
                to="settings/help"
              >
                <HelpCenter fontSize="small" className="mr-2" /> Help Center
              </Link>
            </li>
            <li>
              <Link
                className=" flex p-1 text-small text-gray-500 hover:text-white hover:bg-coffee"
                to="settings/report"
              >
                <Report fontSize="small" className="mr-2" /> Reports
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
